import Hero from '../components/Hero';
import About from '../components/About';
import Benefits from '../components/Benefits';

export default function Home({ setActiveTab }) {
  return (
    <div className="min-h-screen">
      <Hero setActiveTab={setActiveTab} />
      <About />
      <Benefits />
    </div>
  );
}
